module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Heavy.woff?03ade8eade06bfc301c3effe0aead721";